(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/pages/divider.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/pages/divider.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const Image = svs.content.image_v2.Image;
const _svs$ui$ReactCard = svs.ui.ReactCard,
  Card = _svs$ui$ReactCard.Card,
  CardBody = _svs$ui$ReactCard.CardBody;
const Button = svs.ui.Button;
const _svs$ui$ReactGrid = svs.ui.ReactGrid,
  GridCol = _svs$ui$ReactGrid.GridCol,
  GridRow = _svs$ui$ReactGrid.GridRow,
  Grid = _svs$ui$ReactGrid.Grid;
const _ReactRouterDOM = ReactRouterDOM,
  useHistory = _ReactRouterDOM.useHistory;
const WidgetArea = svs.components.tb_ui_react.widget_area.WidgetArea;
const _svs$ticketgames$tick = svs.ticketgames.ticketUtility.utils.tracking,
  trackOrderHomeDividerOrderHomeSelected = _svs$ticketgames$tick.trackOrderHomeDividerOrderHomeSelected,
  trackOrderHomeDividerSubscribeSelected = _svs$ticketgames$tick.trackOrderHomeDividerSubscribeSelected;
setGlobal('svs.ticketsOrderHome.pages.Divider', () => {
  const _svs$ticketsOrderHome = svs.ticketsOrderHome.data.config.divider.topSection,
    headerTitle = _svs$ticketsOrderHome.headerTitle,
    preamble = _svs$ticketsOrderHome.preamble;
  const _svs$ticketsOrderHome2 = svs.ticketsOrderHome.data.config.divider,
    _svs$ticketsOrderHome3 = _svs$ticketsOrderHome2.newCardSection,
    newCardSection = _svs$ticketsOrderHome3 === void 0 ? [] : _svs$ticketsOrderHome3,
    customBg = _svs$ticketsOrderHome2.customBg;
  const Background = svs.ticketsOrderHome.components.Background;
  const history = useHistory();
  const trackCardSelection = link => {
    const subscribeBaseUrl = svs.ticketsOrderHome.routes.SUBSCRIPTION.CHOOSE.split('/').filter(part => part)[0];
    const orderHomeBaseUrl = svs.ticketsOrderHome.routes.ORDER_HOME.CHOOSE.split('/').filter(part => part)[0];
    if (link.includes(subscribeBaseUrl)) {
      trackOrderHomeDividerSubscribeSelected();
    } else if (link.includes(orderHomeBaseUrl)) {
      trackOrderHomeDividerOrderHomeSelected();
    }
  };
  const handleCardOnClick = _ref => {
    let link = _ref.link,
      linkOutsideModule = _ref.linkOutsideModule;
    trackCardSelection(link);
    if (linkOutsideModule) {
      svs.utils.url.navigate("".concat(link));
    } else {
      history.push("".concat(link));
    }
  };
  const cardBlocks = React.useMemo(() => newCardSection.map(block => _objectSpread(_objectSpread({}, block), {}, {
    id: crypto.randomUUID()
  })), [newCardSection]);
  return React.createElement(Background, {
    image: customBg
  }, React.createElement(Grid, null, React.createElement("div", {
    className: "align-content-center padding-1"
  }, React.createElement("div", {
    className: "u-flex u-flex-column u-flex-align-items-center"
  }, React.createElement(GridRow, {
    className: "u-flex-justify-content-center padding-bottom-0"
  }, React.createElement(GridCol, {
    am: 4,
    className: "f-body tickets-order-home-gridcol-top relative",
    lg: 6,
    sm: 12
  }, React.createElement("h1", {
    className: "h1 align-center margin-1 padding-top-1 tickets-order-home-divider-header"
  }, headerTitle), React.createElement("p", {
    className: "p f-content padding-v-1"
  }, preamble))), cardBlocks.map((block, blockIndex) => React.createElement("div", {
    className: "tickets-order-home-block-section w100",
    key: block.id
  }, block.blockTitle && React.createElement(GridRow, {
    className: "u-flex-justify-content-center relative"
  }, React.createElement(GridCol, {
    am: 12,
    lg: 12,
    sm: 12
  }, React.createElement("h2", {
    className: "h2 fc-navy u-text-center margin-bottom-1 margin-top-3"
  }, block.blockTitle), block.blockDescription && React.createElement("p", {
    className: "margin-bottom-0 p tickets-order-home-block-description fc-grey-600 u-text-center"
  }, block.blockDescription))), React.createElement(GridRow, {
    className: "u-flex-justify-content-center tickets-order-home-grid-row ".concat(blockIndex === cardBlocks.length - 1 ? 'padding-bottom-3' : '')
  }, block.cards && block.cards.map(_ref2 => {
    let _ref2$buttonText = _ref2.buttonText,
      buttonText = _ref2$buttonText === void 0 ? 'Fortsätt' : _ref2$buttonText,
      _ref2$buttonStyle = _ref2.buttonStyle,
      buttonStyle = _ref2$buttonStyle === void 0 ? 'focus' : _ref2$buttonStyle,
      image = _ref2.image,
      link = _ref2.link,
      linkOutsideModule = _ref2.linkOutsideModule,
      title = _ref2.title,
      preamble = _ref2.preamble;
    return React.createElement(GridCol, {
      am: 6,
      className: "tickets-order-home-gridcol",
      key: title,
      lg: 6,
      sm: 12
    }, React.createElement(Card, {
      className: "tickets-order-home-media-card-grid h100 padding-1"
    }, React.createElement(CardBody, {
      className: "u-flex u-flex-column"
    }, React.createElement("div", {
      className: "tickets-order-home-media-card-body-grid margin-bottom-1"
    }, React.createElement("div", {
      className: "f-body"
    }, React.createElement("h2", {
      className: "h2 f-content fw-500 margin-bottom-1"
    }, title), React.createElement("p", {
      className: "p f-content"
    }, preamble)), React.createElement("div", {
      className: "u-flex u-flex-justify-content-center u-flex-align-items-center"
    }, image && React.createElement(Image, {
      image: _objectSpread({}, image)
    }))), React.createElement("div", {
      className: "tickets-order-home-margin-top"
    }, React.createElement(Button, {
      className: "w100",
      [buttonStyle]: true,
      onClick: () => handleCardOnClick({
        link,
        linkOutsideModule
      })
    }, buttonText)))));
  })))))), React.createElement(WidgetArea, {
    areaName: "dividerWidget"
  })));
});

 })(window);